import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaStar, FaUserAlt, FaBed, FaExpand, FaArrowRight } from 'react-icons/fa';
import { rooms } from '../../data/hotelData';
import './FeaturedRooms.css';

const featured = rooms.filter(r => r.featured);

function RoomCard({ room, index }) {
  return (
    <motion.div
      className="room-card"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, delay: index * 0.12 }}
    >
      <div className="room-card-img">
        <img src={room.image} alt={room.name} loading="lazy" />
        <div className="room-card-badge">{room.category}</div>
        <div className="room-card-overlay">
          <Link to={`/rooms/${room.name.toLowerCase().replace(/\s+/g, '-')}`} className="room-view-btn">
            View Details <FaArrowRight />
          </Link>
        </div>
      </div>

      <div className="room-card-body">
        <div className="room-card-rating">
          <FaStar className="star-icon" />
          <strong>{room.rating}</strong>
          <span>({room.reviews} reviews)</span>
        </div>

        <h3 className="room-card-name">{room.name}</h3>

        <div className="room-card-meta">
          <span><FaExpand /> {room.size} m²</span>
          <span><FaUserAlt /> Up to {room.capacity}</span>
          <span><FaBed /> {room.beds}</span>
        </div>

        <p className="room-card-desc">{room.description.slice(0, 110)}...</p>

        <div className="room-card-footer">
          <div className="room-card-price">
            <span className="price-from">from</span>
            <strong className="price-value">${room.price}</strong>
            <span className="price-per">/night</span>
          </div>
          <Link to={`/booking`} className="btn btn-primary room-book-btn">
            Book Now
          </Link>
        </div>
      </div>
    </motion.div>
  );
}

export default function FeaturedRooms() {
  return (
    <section className="section featured-rooms" id="featured">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Accommodations</span>
          <h2 className="section-title">Our Featured Rooms & Suites</h2>
          <div className="gold-line" />
          <p className="section-subtitle">
            Each room is a sanctuary of elegance — thoughtfully designed with premium furnishings,
            state-of-the-art amenities, and breathtaking views.
          </p>
        </div>

        <div className="featured-rooms-grid">
          {featured.map((room, i) => (
            <RoomCard key={room.id} room={room} index={i} />
          ))}
        </div>

        <div className="featured-rooms-cta">
          <Link to="/rooms" className="btn btn-outline">
            View All Rooms & Suites <FaArrowRight />
          </Link>
        </div>
      </div>
    </section>
  );
}
